import React from 'react';
import { observer } from 'mobx-react';

import { SessionStore } from '../../../stores/SessionStore';
import { SecondaryButton } from '../../../common/secondary-button';
import { Validator } from '../../../helpers/Validator';
import { Logger } from '../../../helpers/Logger';
import { FAQsController } from '../../../networking/controllers/FAQsController';
import { ProductStore } from '../stores/ProductStore';
import { RecaptchaComponent } from '../../../common/recaptcha-component';
import styles from './MakeQuestionSection.css';
import { Recaptcha } from '../../../helpers/Recaptcha';

// TODO: support filling fields automatically when user is logged in.
class MakeQuestionSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questionText: '',
      questionTextDirty: false,
      userName: SessionStore.loggedIn ? SessionStore.user.userName : '',
      userNameDirty: false,
      email: SessionStore.loggedIn ? SessionStore.user.email : '',
      emailDirty: false,
      emailValid: true,

      submitting: false,
      submitSuccess: false,
      submitError: false,

      recaptchaToken: null,
      recaptchaError: null,
    };
    this._onSubmit = this._onSubmit.bind(this);
    this._updateEmail = this._updateEmail.bind(this);
    this._updateName = this._updateName.bind(this);
    this._updateQuestionText = this._updateQuestionText.bind(this);
    this._dataIsValid = this._dataIsValid.bind(this);

    this._onRecaptchaError = this._onRecaptchaError.bind(this);
    this._onRecaptchaExpiry = this._onRecaptchaExpiry.bind(this);
    this._onRecaptchaSuccess = this._onRecaptchaSuccess.bind(this);
  }

  _dataIsValid() {
    const dataIsValid = (
      !!this.state.userName &&
      !!this.state.email &&
      Validator.isEmail(this.state.email) &&
      !!this.state.questionText &&
      !!this.state.recaptchaToken &&
      !!this.state.userName.trim() &&
      !!this.state.email.trim() &&
      !!this.state.questionText.trim()
    );
    return dataIsValid;
  }

  _updateEmail(event) {
    const { target: { value } } = event;
    this.setState({
      email: value,
      emailDirty: true,
      emailValid: Validator.isEmail(value),
    });
  }

  _updateName(event) {
    const { target: { value } } = event;
    this.setState({
      userName: value,
      userNameDirty: true,
    });
  }

  _updateQuestionText(event) {
    const { target: { value } } = event;
    this.setState({
      questionText: value,
      questionTextDirty: true,
    });
  }

  _onRecaptchaSuccess(token) {
    this.setState({
      recaptchaError: false,
      recaptchaToken: token,
    });
  }

  _onRecaptchaError() {
    this.setState({
      recaptchaError: true,
    });
  }

  _onRecaptchaExpiry() {
    this.setState({
      recaptchaToken: null,
    });
  }

  async _onSubmit(event) {
    event.preventDefault();
    if (!this.state.submitting && this._dataIsValid()) {
      try {
        this.setState({
          submitting: true,
        });
        await FAQsController.create({
          email: this.state.email,
          productId: ProductStore.product.id,
          question: this.state.questionText,
          userId: null,
          userName: this.state.userName,
          recaptchaToken: this.state.recaptchaToken,
        });
        this.setState({
          submitSuccess: true,
        });
      } catch (error) {
        Logger.warn(error);
        this.setState({
          submitError: true,
        });
      } finally {
        this.setState({
          submitting: false,
          recaptchaToken: null,
        });
        Recaptcha.reset();
      }
    }
  }

  render() {
    return (
      <section>
        <h3 className={styles.title}>
          Ingresar una consulta
        </h3>
        <form
          className={styles.form}
          onSubmit={this._onSubmit}
        >
          {
            this.state.questionTextDirty &&
            this.state.questionText === '' &&
            <p className={styles.errorMessage}>
              Debe llenar el campo de pregunta.
            </p>
          }
          <textarea
            className={styles.textarea}
            disabled={this.state.submitSuccess}
            onChange={this._updateQuestionText}
            placeholder="Escriba una pregunta"
            value={this.state.questionText}
          />
          {
            this.state.userNameDirty &&
            this.state.userName === '' &&
            <p className={styles.errorMessage}>
              Debe llenar el campo de nombre.
            </p>
          }
          <input
            className={styles.formElement}
            disabled={this.state.submitSuccess}
            onChange={this._updateName}
            placeholder="Nombre"
            value={this.state.userName}
          />
          {
            this.state.emailDirty &&
            this.state.email === '' &&
            <p className={styles.errorMessage}>
              Debe llenar el campo de email.
            </p>
          }
          {
            !this.state.emailValid &&
            this.state.email !== '' &&
            <p className={styles.errorMessage}>
              El email debe ser válido.
            </p>
          }
          <input
            className={styles.formElement}
            disabled={this.state.submitSuccess}
            onChange={this._updateEmail}
            placeholder="Email"
            value={this.state.email}
          />
          <div className={styles.recaptcha}>
            {
              !!this.state.recaptchaError &&
              <p className={styles.errorMessage}>
                Ha ocurrido un error, intente realizar el reCAPTCHA de nuevo.
              </p>
            }
            <RecaptchaComponent
              onError={this._onRecaptchaError}
              onExpiry={this._onRecaptchaExpiry}
              onSuccess={this._onRecaptchaSuccess}
            />
          </div>
          {
            this.state.submitError &&
            <p className={styles.errorMessage}>
              Ha ocurrido un error, por favor inténtelo nuevamente.
            </p>
          }
          {
            this.state.submitSuccess &&
            <p className={styles.successMessage}>
              Tu consulta se envió con éxito. Te contactaremos a la brevedad.
            </p>
          }
          <SecondaryButton
            className={styles.submitButton}
            disabled={!this._dataIsValid() || this.state.submitSuccess}
          >
            Enviar Consulta
          </SecondaryButton>
        </form>
      </section>
    );
  }
}

const ObservedMakeQuestionSection = observer(MakeQuestionSection);

export { ObservedMakeQuestionSection as MakeQuestionSection };



// WEBPACK FOOTER //
// ./src/pages/product-detail/make-question-section/MakeQuestionSection.jsx